/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, color, centerAbsolutely } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// REWARDS FEEDBACK STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	rewardsfeedback: {
        '&.rewards-false':{
        	'& .icon':{
                background: 'transparent'
			},
			'&.correct-false':{
                '& .text':{
                    marginBottom: pxToEm(8)
                }
			}
        },
		// ..... ELEMENTS ..... //
		'& .icon, .text': {
			display: 'inline-block',
			verticalAlign: 'middle'
		},
		'& .icon': {
			background: color.rewards,
			borderRadius: '50%',
			width: pxToEm(50),
			height: pxToEm(50),
			marginRight: pxToEm(4),
			transition: 'background .2s linear 0s',
			textAlign: 'center',
			position: 'relative',
			'& .value': {
				extend: centerAbsolutely,
				color: color.white,

				'& .number': {
					display: 'block',
					fontSize: pxToEm(22),
					fontWeight: '600',
					lineHeight: '1',
					'&.large': {
						fontSize: pxToEm(18)
					}
				},
				'& .pts': {
					display: 'block',
					fontSize: pxToEm(12),
					fontWeight: 'normal',
					lineHeight: '1'
				}
			}
		},
		'& .text': {
			color: color.white,
			fontSize: pxToEm(16),
            '&.large-true': {
                fontSize: '115%'
            }
		},


		// ..... STATES ..... //
		// '&.correct': {
		// 	'& .icon': {
		// 		background: color.green
		// 	}
		// },
		// '&.incorrect': {
		// 	'& .icon': {
		// 		background: color.red
		// 	}
		// }
	}
};
